import React, { memo, useCallback } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { dtmfButtonStyles } from '../../../../MobileCallSurface.styles';

const DtmfKey = ({ digit, onPress }) => {
  const onClick = useCallback(() => {
    onPress(digit);
  }, [digit, onPress]);

  return (
    <Box
      aria-label={`Dial ${digit}`}
      component="button"
      data-testid={`mobile-call-dtmf-${digit}`}
      sx={dtmfButtonStyles}
      onClick={onClick}
    >
      {digit}
    </Box>
  );
};

DtmfKey.propTypes = {
  digit: PropTypes.string.isRequired,
  onPress: PropTypes.func.isRequired,
};

export default memo(DtmfKey);
